<template>
    <div>
        <LsInputLabel
            v-if="label || subLabel || collapseContent"
            :label="label"
            :sub-label="subLabel"
            :collapse-content="collapseContent"
            :error="getValidation.invalid"
        />
        <BField :type="`${getValidation.invalid ? 'is-error' : 'is-secondary-light'}`">
            <BInput
                v-model="localValue"
                v-validate="validation"
                :placeholder="getPlaceholder"
                test-id="ls-input"
                :disabled="disabled || loading"
                :name="name"
                :type="type"
                :password-reveal="type === 'password'"
                :maxlength="maxlength"
                :has-counter="hasCounter"
                :loading="loading"
                :readonly="readonly"
                custom-class="ls-input--input"
                @blur="onBlur"
            ></BInput>
        </BField>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import _ from 'lodash';
import LsInputLabel from '../LsInputLabel/LsInputLabel.vue';

export default {
    name: 'LsInput',
    inject: ['$validator'],
    components: {
        LsInputLabel,
    },
    props: {
        value: VueTypes.string.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        name: VueTypes.string.isRequired,
        label: VueTypes.string,
        subLabel: VueTypes.string,
        collapseContent: VueTypes.string,
        placeholder: VueTypes.string,
        type: VueTypes.oneOf(['text', 'email', 'textarea', 'number', 'tel', 'password']).def(
            'text'
        ),
        disabled: VueTypes.bool.def(false),
        validation: VueTypes.object.def(_.constant(null)),
        maxlength: VueTypes.string,
        hasCounter: VueTypes.bool.def(false),
        loading: VueTypes.bool.def(false),
        readonly: VueTypes.bool.def(false),
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        getPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            } else if (this.type === 'textarea') {
                return 'Enter details...';
            }
            return '';
        },
        getValidation() {
            return lsValidationService.getValidation.call(this);
        },
    },
    methods: {
        onBlur(e) {
            const { value } = e.target;
            lsTrackingService.track({
                event: 'blur',
                target: this.trackId,
            });
            this.$emit('blur', value);
        },
    },
};
</script>

<style lang="scss">
.control {
    .ls-input--input {
        border-radius: $border-radius;
        box-shadow: none;
        height: 36px;
    }
}
.mdi-eye::after {
    content: url(eye.svg);
    position: absolute;
    top: 4px;
    left: 4px;
}

.mdi-eye-off::after {
    content: url(eye-off.svg);
    position: absolute;
    top: 4px;
    left: 4px;
}
</style>
